import {
  RuntimeConfigValue,
  TripodContextData,
} from '@moment/context/TripodContext.tsx';

export const isPartnerExternalFotoscapeLink = (
  tripodContextData: TripodContextData | undefined,
  partner: string
): boolean => {
  if (!tripodContextData?.runtimeConfig || !partner) {
    return false;
  }
  const linkMap: Record<string, string> =
    tripodContextData?.runtimeConfig?.externalFotoscapesLink;
  return linkMap ? linkMap[partner]?.toLowerCase() === 'true' : false;
};

export const getRuntimeConfigValues = (
  runtimeConfigData: Map<string, Record<string, string>>
): RuntimeConfigValue => {
  const runtimeConfig: RuntimeConfigValue = {};
  if (!runtimeConfigData) {
    return runtimeConfig;
  }
  for (const key of runtimeConfigData.keys()) {
    if (runtimeConfigData.get(key)) {
      runtimeConfig[key] = runtimeConfigData.get(key);
    }
  }
  for (const [key, value] of runtimeConfigData.entries()) {
    runtimeConfig[key] = value;
  }
  return runtimeConfig;
};
